import { useLocation } from 'react-router';
import { Nav, Navbar } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import useBreakPoints from '../../hooks/useBreakPoints';
import useGeneralRetailers from '../../hooks/useGeneralRetailers';

import ToyotaLogo from '../../assets/images/toyota_logo.svg';

import './styles.scss';

const Header = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { data } = useGeneralRetailers();
  const { isSmallerThanMd } = useBreakPoints();

  const firstParamInPath = pathname.split('/')[1];
  const currentRetailer = data?.find(({ Key }) => Key === firstParamInPath);

  return (
    <>
      <Navbar role="navigation" aria-label={t('SpecialOffers')}>
        <Navbar.Brand>
          <a className="logo-wrap" href={t('ToyotaHomePage')} aria-label="Toyota">
            <img src={ToyotaLogo} alt="Toyota logo" />
          </a>
        </Navbar.Brand>
        <Nav className="justify-content-between w-100">
          <Nav.Item>
            <Nav.Link
              href={`/${currentRetailer ? currentRetailer.Key : ''}`}
              eventKey={`/${currentRetailer ? currentRetailer.Key : ''}`}
              active
            >
              {t('SpecialOffers')}
            </Nav.Link>
          </Nav.Item>
        </Nav>
        {!isSmallerThanMd ? (
          <div className="d-flex">
            {t('AlternateCountryUrl') === '-' ? null : (
              <a
                href={t('AlternateCountryUrl')}
                className={`language ${
                  currentRetailer ? 'with-retailer' : 'mr-md-5'
                }`}
              >
                {t('AlternativeCountryText')}
              </a>
            )}
            {currentRetailer ? (
              <Navbar.Brand className="retailer">
                <a
                  href={currentRetailer.HomePageUrl}
                  className="logo-wrap"
                  aria-label={currentRetailer.Name || 'Retailer'}
                >
                  <img src={currentRetailer.LogoLocation} alt={currentRetailer.Name || 'Retailer logo'} />
                </a>
              </Navbar.Brand>
            ) : null}
          </div>
        ) : (
          <>
            {t('AlternateCountryUrl') === '-' ? null : (
              <a
                href={t('AlternateCountryUrl')}
                className={`language ${currentRetailer ? '' : 'mr-md-5'}`}
              >
                {t('AlternativeCountryText')}
              </a>
            )}
          </>
        )}
      </Navbar>
      {isSmallerThanMd && currentRetailer ? (
        <Navbar className="sm-retailer-logo">
          <Navbar.Brand className="retailer">
            <a
              href={currentRetailer.HomePageUrl}
              className="logo-wrap-sm"
              aria-label={currentRetailer.Name || 'Retailer'}
            >
              <img src={currentRetailer.LogoLocation} alt={currentRetailer.Name || 'Retailer logo'} />
            </a>
          </Navbar.Brand>
        </Navbar>
      ) : null}
    </>
  );
};

export default Header;
